<div infiniteScroll
     [infiniteScrollDistance]="scrollDistance"
     [infiniteScrollUpDistance]="scrollDistanceUp"
     [infiniteScrollContainer]="infiniteScrollContainer"
     [infiniteScrollThrottle]="infiniteScrollThrottle"
     [scrollWindow]="scrollWindow"
     [fromRoot]="fromRoot"
     (scrolled)="onScrollDown()"
     (scrolledUp)="onScrollUp()">
  <ng-content></ng-content>
</div>



// WEBPACK FOOTER //
// ./src/app/core/achoo-infinite-scroll/achoo-infinite-scroll.component.html